module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-47.dbc8e40.woff2";